export default "__VITE_ASSET__CJnFfE2e__"